import { authStore } from "@kaplan-labs/up-auth-api-client";

import { themeStore } from "@up/data";

import { getOneTrustConsent } from "./useOneTrustConsent";

import type { AnalyticsData } from "./types";

export const VIRTUAL_PAGEVIEW = "virtualPageview";

export const analyticsEvent = (data: AnalyticsData) => {
  const $theme = themeStore.get();
  const $auth = authStore.get();

  const isVirtualPageview = data?.event === VIRTUAL_PAGEVIEW;

  const payload: Record<string, unknown> = {
    partner: $theme.analyticsPartnerName,
    url: window.location.href,
    ...data,
  };

  if ($auth.currentUser) {
    payload["user_id"] = $auth.currentUser.id;
    payload["contact_id"] = $auth.currentUser.contactId;
    payload["user_email"] = $auth.currentUser.email;
  }

  const catalogueId = document.querySelector("meta#catalogueid");
  if (catalogueId) {
    payload["catalogue_id"] = catalogueId.getAttribute("content");
  }

  const courseName = document.querySelector("meta#coursename");
  if (courseName) {
    payload["course"] = courseName.getAttribute("content");
  }

  if (process.env["NEXT_PUBLIC_GTM_TRACKING_ID"] && window.dataLayer) {
    window.dataLayer.push(payload);
  } else {
    console.log("analyticsEvent: ", payload);
  }

  // Heap is a performance/analytics tool, so only forward events once the
  // visitor has granted performance consent (C0002). This mirrors the loader
  // gate in FrontendInit and guards the direct-call path: window.heap can still
  // be defined while suspended or mid-load, so leaning on Heap's own `loaded`
  // kill-switch alone would leak events queued during a load-then-revoke race.
  if (!isVirtualPageview && getOneTrustConsent().performanceCookies === 1) {
    window.heap?.track(data.event, payload);
  }
};

export const pageview = (url: string) => {
  analyticsEvent({ event: VIRTUAL_PAGEVIEW, virtualUrl: url });
};

export function gtmScript(id: string) {
  if (!/^GTM-[A-Z0-9]+$/.test(id)) {
    console.log(`Invalid GTM ID: ${id}`);
    return "";
  }

  return `
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ originalLocation: window.location.href });
    (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
            'gtm.start': new Date().getTime(), event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${id}');
  `;
}
